import React from "react";
import PropTypes from "prop-types";

function ValidationErrorModal({ isOpen, title = "Validation Error", errors = [], onClose }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity"
                onClick={onClose}
            />

            {/* Modal */}
            <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden transform transition-all">
                {/* Content */}
                <div className="px-6 py-8 space-y-6">
                    {/* Error Icon */}
                    <div className="flex justify-center">
                        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
                            <svg
                                className="w-8 h-8 text-red-600"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                />
                            </svg>
                        </div>
                    </div>

                    {/* Title and Messages */}
                    <div className="text-center space-y-3">
                        <h3 className="text-2xl font-semibold text-gray-900">
                            {title}
                        </h3>
                        <div className="text-sm text-gray-600 space-y-2 max-h-60 overflow-y-auto px-2">
                            {errors.map((error, idx) => (
                                <p key={idx} className="flex items-start gap-2 text-left bg-red-50 p-2 rounded border border-red-100">
                                    <span className="text-red-500 font-bold mt-0.5">•</span>
                                    <span>{error}</span>
                                </p>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Action Button */}
                <div className="px-6 pb-6">
                    <button
                        onClick={onClose}
                        className="w-full px-4 py-3 bg-gray-800 hover:bg-gray-900 text-white rounded-lg font-medium transition-colors shadow-sm"
                    >
                        Understood, Let me fix it
                    </button>
                </div>
            </div>
        </div>
    );
}

ValidationErrorModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    title: PropTypes.string,
    errors: PropTypes.arrayOf(PropTypes.string).isRequired,
    onClose: PropTypes.func.isRequired,
};

export default ValidationErrorModal;
